import { Component, Inject } from '@angular/core';
import { StationGroup } from '../../../../../client/model/station-group';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StructureSelection, StructureSelectionRequest, StructureSelectionScope } from '../../../structure-selection.model';

@Component({
    selector: 'app-structure-selection-dialog',
    templateUrl: './structure-selection-dialog.component.html',
    styleUrls: ['./structure-selection-dialog.component.scss'],
    standalone: false
})
export class StructureSelectionDialogComponent {


  stationGroups: Array<StationGroup>;

  selectedStationGroup: StationGroup = null;

  selection: StructureSelection;

  constructor(
    private dialog: MatDialogRef<StructureSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public request: StructureSelectionRequest,
  ) {

  }

  confirmDialog() {
    this.dialog.close(this.selection);
  }

  cancelDialog() {
    this.dialog.close(null);
  }

  handleSelectionChange(selection: StructureSelection) {
    console.log('handling selection', selection);
    this.selection = selection;
  }

}
